var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i-table',{attrs:{"stripe":"","data":_vm.list,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }